import * as React from 'react';
import { useSelector } from 'react-redux';
import { ModalWindow } from '@cian/ui-kit';

import { OnboardingContainer } from '../../parts';

import { useAppDispatch } from '../../../../hooks';
import {
  trackCloseOnboardingModal,
  trackShowOnboardingModal,
  trackClickOnboardingButton,
  trackClickOnboardingBackButton,
} from './tracking';

import { selectIsHomeProfitOnboardingOpen } from '../../../../selectors/page';
import { openHomeProfileOnboardingModal } from '../../../../slices';
import { ONBOARDING_SLIDES } from './content';
import { IOnboardingProps } from '../../types';

export const HomeProfitOnboardingContainer: React.FC<Pick<IOnboardingProps, 'onFinishClick'>> = ({ onFinishClick }) => {
  const dispatch = useAppDispatch();

  const isOnboardingModalOpen = useSelector(selectIsHomeProfitOnboardingOpen);

  const handleCloseModal = React.useCallback(() => {
    dispatch(openHomeProfileOnboardingModal(false));
    trackCloseOnboardingModal();
  }, [dispatch]);

  return (
    <ModalWindow open={isOnboardingModalOpen} onClose={handleCloseModal}>
      <OnboardingContainer
        slides={ONBOARDING_SLIDES}
        trackShowOnboardingModal={trackShowOnboardingModal}
        trackClickOnboardingButton={trackClickOnboardingButton}
        trackClickOnboardingBackButton={trackClickOnboardingBackButton}
        closeOnboardingModal={handleCloseModal}
        onFinishClick={onFinishClick}
      />
    </ModalWindow>
  );
};
